import { render } from "./CharaAchievementTypeList.vue?vue&type=template&id=5f64bd8b"
import script from "./CharaAchievementTypeList.vue?vue&type=script&lang=js"
export * from "./CharaAchievementTypeList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__